export default {
    'staff': [
        {
            type: 'link',
            name: '员工工作台',
            icon: 'xiaoyuandian',
            path: '/console-staff/',
            exact: 'index'
        },
        {
            type: 'link',
            name: '应用中心',
            exact: 'my-app',
            icon: 'xiaoyuandian',
            path: '/console-staff/my-app',
        },
        {
            type: 'link',
            name: '订单中心',
            exact: 'order',
            icon: 'xiaoyuandian',
            path: '/console-staff/order'
        }, 
        {
            type: 'list',
            name: '财务中心',
            icon: 'xiaoyuandian',
            label: 'finance',
            unfold: false,
            list: [
                {
                type: 'link',
                name: '账户信息',
                exact: 'finance-info',
                icon: '',
                path: '/console-staff/finance/info',
                },
            ]
        },
        // {
        //     type: 'list',
        //     name: '组织架构',
        //     icon: 'xiaoyuandian',
        //     label: 'organization',
        //     unfold: false,
        //     list: [
        //         {
        //             type: 'link',
        //             name: '成员与部门',
        //             exact: 'organization-info',
        //             icon: '',
        //             path: '/console-staff/structureModule/structure',
        //         },
        //         {
        //             type: 'link',
        //             name: '角色设置',
        //             exact: 'organization-info',
        //             icon: '',
        //             path: '/console-staff/structureModule/roleSetting',
        //         },
        //         {
        //             type: 'link',
        //             name: '职位',
        //             exact: 'organization-info',
        //             icon: '',
        //             path: '/console-staff/structureModule/position',
        //         },
        //     ]
        // },
        {
            type: 'list',
            name: '消息中心',
            icon: 'xiaoyuandian',
            label: 'message',
            unfold: false,
            list: [
                {
                    type: 'link',
                    name: '公告发布',
                    exact: 'message',
                    icon: '',
                    path: '/console-staff/message/release'
                },
                {
                    type: 'link',
                    name: '消息列表',
                    exact: 'message',
                    icon: '',
                    path: '/console-staff/message'
                },
            ]
        },
        {
            type: 'list',
            name: '权限管理',
            icon: 'xiaoyuandian',
            label: 'privilege',
            unfold: false,
            list: [
                {
                    type: 'link',
                    name: '员工授权',
                    exact: 'privilege',
                    icon: '',
                    path: '/console-staff/power/authority/staff'
                },
                {
                    type: 'link',
                    name: '权限模板',
                    exact: 'privilege',
                    icon: '',
                    path: '/console-staff/power/authority/role'
                },
                {
                    type: 'link',
                    name: '历史记录',
                    exact: 'privilege',
                    icon: '',
                    path: '/console-staff/power/authority/record'
                },
            ]
        },
        // {
        //     type: 'list',
        //     name: '智能表单',
        //     icon: 'xiaoyuandian',
        //     label: 'form',
        //     unfold: false,
        //     list: [
        //         {
        //             type: 'link',
        //             name: '表单管理',
        //             icon: '',
        //             path: '/console-staff/formModule/formManage',
        //             exact: 'form-info'
        //         }, 
        //         {
        //             type: 'link',
        //             name: '使用表单',
        //             icon: '',
        //             path: '/console-staff/formModule/useForm',
        //             exact: 'form-info'
        //         }, 
        //         {
        //             type: 'link',
        //             name: '推荐表单',
        //             icon: '',
        //             path: '/console-staff/formModule/recommendationFormList',
        //             exact: 'form'
        //         },
        //         {
        //             type: 'link',
        //             name: '表单日志',
        //             icon: '',
        //             path: '/console-staff/formModule/formLogList',
        //             exact: 'form'
        //         },
        //     ]
        // },
        {
            type: 'list',
            name: '个人设置',
            icon: 'xiaoyuandian',
            label: 'account',
            unfold: false,
            list: [{
                type: 'link',
                name: '个人资料',
                icon: '',
                path: '/console-staff/person/info',
                exact: 'person-info'
            }, {
                type: 'link',
                name: '账号信息',
                icon: '',
                path: '/console-staff/account/info',
                exact: 'account-info'
            }, {
                type: 'link',
                name: '密码修改',
                icon: '',
                path: '/console-staff/account/password',
                exact: 'account-password'
            }]
        }
    ],
    "person" :[
        {
            type: 'link',
            name: '我的工作台',
            exact: 'index',
            icon: 'xiaoyuandian',
            path: '/console/'
        },
        {
            type: 'list',
            name: '订阅中心',
            icon: 'xiaoyuandian',
            label: 'goods',
            unfold: false,
            list: [
                {
                    type: 'link',
                    name: '应用中心',
                    exact: 'goods',
                    icon: '',
                    path: '/console/goods/center'
                },
                {
                    type: 'link',
                    name: '购买记录',
                    exact: 'goods',
                    icon: '',
                    path: '/console/goods/record'
                },
            ]
        },
       
        {
            type: 'list',
            name: '订单中心',
            icon: 'xiaoyuandian',
            label: 'finance',
            unfold: false,
            list: [
                {
                    type: 'link',
                    name: '我购买的订单',
                    exact: 'finance-info',
                    icon: '',
                    path: '/console/orders/buylist',
                },
                {
                    type: 'link',
                    name: '我出售的订单',
                    exact: 'finance-info',
                    icon: '',
                    path: '/console/orders/selllist',
                },
                {
                    type: 'link',
                    name: '我申请的退款',
                    exact: 'finance-info',
                    icon: '',
                    path: '/console/orders/applylist',
                },
                {
                    type: 'link',
                    name: '我处理的退款',
                    exact: 'finance-info',
                    icon: '',
                    path: '/console/orders/handlelist',
                },
                {
                    type: 'link',
                    name: '评价管理',
                    exact: 'finance-info',
                    icon: '',
                    path: '/console/appraise',
                }
            ]
        },
        {
            type: 'list',
            name: '财务中心',
            icon: 'xiaoyuandian',
            label: 'finance',
            unfold: false,
            list: [{
                type: 'link',
                name: '账户信息',
                exact: 'finance-info',
                icon: '',
                path: '/console/finance/info',
            },
            {
                type: 'link',
                name: '转出',
                exact: 'extract',
                icon: '',
                path: '/console/finance/extract'
            },
            {
                type: 'link',
                name: '购买人是币',
                exact: 'recharge',
                icon: '',
                path: '/console/finance/recharge'
            },
            {
                type: 'link',
                name: '开票管理',
                exact: 'invoice',
                icon: '',
                path: '/console/finance/invoice'
            }]
        },
        {
            type: 'list',
            name: '消息中心',
            icon: 'xiaoyuandian',
            label: 'message',
            unfold: false,
            list: [
            {
                type: 'link',
                name: '消息列表',
                exact: 'message',
                icon: '',
                path: '/console/message'
            }]
        },
        {
            type: 'list',
            name: '个人设置',
            icon: 'xiaoyuandian',
            label: 'account',
            unfold: false,
            list: [{
                type: 'link',
                name: '个人资料',
                icon: '',
                path: '/console/person/info',
                exact: 'person-info'
            }, {
                type: 'link',
                name: '账号信息',
                icon: '',
                path: '/console/account/info',
                exact: 'account-info'
            }, {
                type: 'link',
                name: '密码修改',
                icon: '',
                path: '/console/account/password',
                exact: 'account-password'
            }]
        }
    ],

    'company': [
        {
            type: 'link',
            name: '我的工作台',
            exact: 'index',
            icon: 'xiaoyuandian',
            path: '/console/'
        },
        {
            type: 'list',
            name: '订阅中心',
            icon: 'xiaoyuandian',
            label: 'goods',
            unfold: false,
            list: [
                {
                    type: 'link',
                    name: '应用中心',
                    exact: 'goods',
                    icon: '',
                    path: '/console/goods/center'
                },
                {
                    type: 'link',
                    name: '购买记录',
                    exact: 'goods',
                    icon: '',
                    path: '/console/goods/record'
                },
            ]
        },
        {
            type: 'list',
            name: '订单中心',
            icon: 'xiaoyuandian',
            label: 'finance',
            unfold: false,
            list: [
                {
                    type: 'link',
                    name: '我购买的订单',
                    exact: 'finance-info',
                    icon: '',
                    path: '/console/orders/buylist',
                },
                {
                    type: 'link',
                    name: '我出售的订单',
                    exact: 'finance-info',
                    icon: '',
                    path: '/console/orders/selllist',
                },
                {
                    type: 'link',
                    name: '我申请的退款',
                    exact: 'finance-info',
                    icon: '',
                    path: '/console/orders/applylist',
                },
                {
                    type: 'link',
                    name: '我处理的退款',
                    exact: 'finance-info',
                    icon: '',
                    path: '/console/orders/handlelist',
                },
                {
                    type: 'link',
                    name: '评价管理',
                    exact: 'finance-info',
                    icon: '',
                    path: '/console/appraise',
                }
            ]
        },

        {
            type: 'list',
            name: '财务中心',
            icon: 'xiaoyuandian',
            label: 'finance',
            unfold: false,
            list: [{
                type: 'link',
                name: '账户信息',
                exact: 'finance-info',
                icon: '',
                path: '/console/finance/info',
            },
            {
                type: 'link',
                name: '转出',
                exact: 'extract',
                icon: '',
                path: '/console/finance/extract'
            },
            {
                type: 'link',
                name: '购买人是币',
                exact: 'recharge',
                icon: '',
                path: '/console/finance/recharge'
            },
            {
                type: 'link',
                name: '开票管理',
                exact: 'invoice',
                icon: '',
                path: '/console/finance/invoice'
            }]
        },
        {
            type: 'list',
            name: '企业中心',
            icon: 'xiaoyuandian',
            label: 'company',
            unfold: false,
            list: [
                {
                    type: 'link',
                    name: '企业认证',
                    exact: 'company-verify',
                    icon: '',
                    path: '/console/company/verify'
                },
                {
                    type: 'link',
                    name: '企业基本信息',
                    exact: 'company-info',
                    icon: '',
                    path: '/console/company/info',
                },
            
            ]
        },
        {
            type: 'list',
            name: '账号设置',
            icon: 'xiaoyuandian',
            label: 'account',
            unfold: false,
            list: [{
                type: 'link',
                name: '账号信息',
                exact: 'account-info',
                icon: '',
                path: '/console/account/info',
            },
            {
                type: 'link',
                name: '密码修改',
                exact: 'password',
                icon: '',
                path: '/console/account/password'
            }]
        },
        {
            type: 'list',
            name: '组织架构',
            icon: 'xiaoyuandian',
            label: 'organization',
            unfold: false,
            list: [
                {
                    type: 'link',
                    name: '成员与部门',
                    exact: 'organization-info',
                    icon: '',
                    path: '/console/structureModule/structure',
                },
                {
                    type: 'link',
                    name: '角色设置',
                    exact: 'organization-info',
                    icon: '',
                    path: '/console/structureModule/roleSetting',
                },
                {
                    type: 'link',
                    name: '职位',
                    exact: 'organization-info',
                    icon: '',
                    path: '/console/structureModule/position',
                },
                {
                    type: 'link',
                    name: '职级',
                    icon: '',
                    path: '/console/structureModule/positionClass',
                    label: 'organization/rank',
                    exact: 'positionClass',
                }
            ]
        },
        {
            type: 'list',
            name: '消息中心',
            icon: 'xiaoyuandian',
            label: 'message',
            unfold: false,
            list: [
                {
                    type: 'link',
                    name: '公告发布',
                    exact: 'message',
                    icon: '',
                    path: '/console/message/release'
                },
                {
                    type: 'link',
                    name: '消息列表',
                    exact: 'message',
                    icon: '',
                    path: '/console/message'
                },
            ]
        },
        {
            type: 'list',
            name: '权限管理',
            icon: 'xiaoyuandian',
            label: 'privilege',
            unfold: false,
            list: [
                {
                    type: 'link',
                    name: '员工授权',
                    exact: 'privilege',
                    icon: '',
                    path: '/console/power/authority/staff'
                },
                {
                    type: 'link',
                    name: '权限模板',
                    exact: 'privilege',
                    icon: '',
                    path: '/console/power/authority/role'
                },
                {
                    type: 'link',
                    name: '历史记录',
                    exact: 'privilege',
                    icon: '',
                    path: '/console/power/authority/record'
                },
            ]
        },
        {
            type: 'list',
            name: '智能表单',
            icon: 'xiaoyuandian',
            label: 'form',
            unfold: false,
            list: [
                {
                    type: 'link',
                    name: '表单管理',
                    icon: '',
                    path: '/console/formModule/formManage',
                    exact: 'form-info'
                }, 
                {
                    type: 'link',
                    name: '使用表单',
                    icon: '',
                    path: '/console/formModule/useForm',
                    exact: 'form-info'
                }, 
                {
                    type: 'link',
                    name: '推荐表单',
                    icon: '',
                    path: '/console/formModule/recommendationFormList',
                    exact: 'form'
                },
                {
                    type: 'link',
                    name: '表单日志',
                    icon: '',
                    path: '/console/formModule/formLogList',
                    exact: 'form'
                },
            ]
        },
    ]
}
